import { Page } from '@/core/architecture'

import { PaymentStatusDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PaymentStatusDetail Page
 * Implemented as a practical sample.
 */
export const PaymentStatusDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <PaymentStatusDetailTemplate state={state} {...actions} />
}
